import { useState } from "react";
import { MathShell, Field, ResultCard, MATH_ACCENT } from "./MathShell.jsx";
import { solveQuadratic, round } from "./mathcore.js";

export default function Quadratic() {
  const [a, setA] = useState("1");
  const [b, setB] = useState("-5");
  const [c, setC] = useState("6");
  const [res, setRes] = useState(null);

  const go = () => {
    const A = parseFloat(a), B = parseFloat(b), C = parseFloat(c);
    if ([A, B, C].some((v) => isNaN(v))) { setRes({ err: "Enter numbers for a, b, c" }); return; }
    setRes(solveQuadratic(A, B, C));
  };

  const fmtRoot = (r) =>
    typeof r === "object" ? `${round(r.re, 6)} ${r.im >= 0 ? "+" : "−"} ${Math.abs(round(r.im, 6))}i` : `${round(r, 6)}`;

  return (
    <MathShell title="Quadratic Solver">
      <p style={{ fontSize: 14, color: "#9A9DBE", marginTop: 0 }}>Solve ax² + bx + c = 0</p>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10 }}>
        <Field label="a" value={a} onChange={(e) => setA(e.target.value)} inputMode="decimal" />
        <Field label="b" value={b} onChange={(e) => setB(e.target.value)} inputMode="decimal" />
        <Field label="c" value={c} onChange={(e) => setC(e.target.value)} inputMode="decimal" />
      </div>
      <button onClick={go} style={btn}>Solve</button>
      {res && res.err && <ResultCard><span style={{ color: "#F8716A" }}>{res.err}</span></ResultCard>}
      {res && !res.err && (
        <ResultCard>
          <div style={{ fontSize: 13, color: "#9A9DBE", marginBottom: 10 }}>WORKED STEPS</div>
          {res.steps.map((s, i) => (
            <div key={i} style={{ fontSize: 14, marginBottom: 6, color: "#C8CADF" }}>{s}</div>
          ))}
          <div style={{ marginTop: 14, fontSize: 17, fontWeight: 700, color: MATH_ACCENT }}>
            {res.roots.length === 0 ? "No solution" : res.roots.map(fmtRoot).map((r, i) => <div key={i}>x{res.roots.length > 1 ? (i + 1) : ""} = {r}</div>)}
          </div>
        </ResultCard>
      )}
    </MathShell>
  );
}
const btn = { marginTop: 4, width: "100%", background: MATH_ACCENT, color: "#06201C", fontWeight: 700, fontSize: 16, border: "none", borderRadius: 12, padding: "14px 0", cursor: "pointer" };

